import { Component, OnInit, input } from '@angular/core';

@Component({
    selector: 'app-loader-indicator',
    templateUrl: './loading-indicator.component.html',
    standalone: false
})
export class LoaderIndicatorComponent {
  readonly loading = input<boolean>(false);

  constructor() {}
}
